var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"empty-main"}},[_c('div',[_c('img',{staticClass:"image-tip",attrs:{"src":require("@/assets/empty.png")}}),_c('p',{staticClass:"empty-title"},[_vm._v("\n      "+_vm._s(_vm.emptyData)+"\n    ")]),_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }